const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function fetchProductFeed(params = {}) {
  const query = new URLSearchParams(params).toString();
  const url = `${BASE_URL}/public/products/feed${query ? `?${query}` : ''}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch products: ${response.status}`);
  }
  return response.json();
}
